import { Stack } from '@mui/material';
import ExplanationTooltip from '../ExplanationTooltip';
import DownloadButton from '../DownloadButton';
import * as React from 'react';

const ChartButtons = () => {
	return (
		<Stack spacing={'5px'} direction={'row'}>
			<ExplanationTooltip />
			<DownloadButton />
		</Stack>
	);
};

export default ChartButtons;
